import * as React from "react";
import type { SVGProps } from "react";
const SvgVoicemail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 11.5A3.5 3.5 0 0 1 5.5 15v2a5.5 5.5 0 0 0 5.5-5.5zM5.5 15A3.5 3.5 0 0 1 2 11.5H0A5.5 5.5 0 0 0 5.5 17zM2 11.5A3.5 3.5 0 0 1 5.5 8V6A5.5 5.5 0 0 0 0 11.5zM5.5 8A3.5 3.5 0 0 1 9 11.5h2A5.5 5.5 0 0 0 5.5 6zM22 11.5a3.5 3.5 0 0 1-3.5 3.5v2a5.5 5.5 0 0 0 5.5-5.5zM18.5 15a3.5 3.5 0 0 1-3.5-3.5h-2a5.5 5.5 0 0 0 5.5 5.5zM15 11.5A3.5 3.5 0 0 1 18.5 8V6a5.5 5.5 0 0 0-5.5 5.5zM18.5 8a3.5 3.5 0 0 1 3.5 3.5h2A5.5 5.5 0 0 0 18.5 6zm-13 9h13v-2h-13z"
    />
  </svg>
);
export default SvgVoicemail;
